
<v-container class="step-container" v-if="data.visible && unit && current">
    <inc-bid-zoom
        v-if   = "zoom"
        :bid   = "selected"
        :data  = "data"
        :form  = "form"
        @close = "onCloseZoom"
    />

    <v-row class="no-frame" style="position: relative">
        <div class="component-zoom-panel step-first-column" v-if="zoomComponents">
            <div class="component-close-button">
                <c-toolbar-button
                    size     = "28"
                    color    = "red"
                    icon     = "mdi-close"
                    :tooltip = "$t('common.cancel')"
                    @click   = "zoomComponents = false"
                />
            </div>

            <inc-components
                v-model     = "current.components"
                :site       = "unit"
                :warranties = "warranties"
                :incident   = "incident"
                :status     = "status"
                :height     = "525"
                :zoom-allowed       = "false"
                style       = "border-radius: 5px 0 5px 5px; margin-top: -1px"
                @input      = "onComponents"
                @zoom       = "onZoomComponents"
                class       = "w-100 mt-2"
            />
        </div>

        <v-col class="step-first-column">

            <c-drop-message
                v-if     = "drag.notAllowed"
                :message = "drag.message"
                style    = "margin-left: 0"
            />

            <drop class="cut h-100" @drop="onDrop" mode="cut" :accepts-type="onAcceptType" ref="droparea">
                <div style="overflow-y: auto; width: calc(100% + 12px); max-height: 665px; height: 665px; padding-right: 3px">

                    <v-row class="no-frame mt-0" v-if="!isModernization">
                        <v-col class="no-frame col-6 pr-2" >
                            <inc-site-down-switch
                                v-if      = "!previous"
                                v-model   = "current.unitDown"
                                class     = "mt-n1"
                            />
                        </v-col>
                        <v-col class="no-frame v-flex col-6 pl-2">
                            <v-switch
                                v-if    = "!isFullMaintenance"
                                v-model = "data.invoice"
                                label   = "Rechnung"
                                @change = "onInvoice"
                                class   = "mt-0 mb-2 pt-0"
                                :class  = "incident.warrenties? 'pr-7' : ''"
                                :ripple = "false"
                                hide-details
                            />

                            <v-switch
                                v-if    = "isFullMaintenance"
                                v-model = "current.notIncludedInFullMaintenance"
                                label   = "nicht in Vollwartung "
                                @change = "onNotIncludedInFullMaintenance"
                                :ripple ="false"
                                class   = "mt-0 mb-2 pt-0"
                                hide-details
                            />
                        </v-col>
                    </v-row>

                    <v-row class="no-frame mt-0" v-if="!isFullMaintenance">
                        <v-col class="no-frame col-6 pr-2" >
                        </v-col>
                        <v-col class="no-frame v-flex col-6 pl-2">
                            <v-switch
                                v-if    = "isFullMaintenance && current.notIncludedInFullMaintenance"
                                v-model = "data.invoice"
                                label   = "Rechnung"
                                @change = "onInvoice"
                                class   = "mt-0 mb-2 pt-0"
                                :class  = "incident.warrenties? 'pr-8' : ''"
                                :ripple = "false"
                                hide-details
                            />
                        </v-col>
                    </v-row>

                    <v-row class="no-frame" v-if="index === 0">
                        <v-col class="no-frame pr-2 col-6">
                            <msd-users
                                v-model="incident.responsible"
                                :background = "fileEntryFieldBackground"
                            />
                        </v-col>

                        <v-col class="no-frame pl-2 pr-2" v-if="isModernization">
                            <v-text-field
                                v-if           = "collective"
                                label          = "Projektnummer"
                                v-model        = "data.projectnumber"
                                :background-color = "fileEntryFieldBackground"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                            />
                            <v-text-field
                                v-if           = "!collective"
                                label          = "Projektnummer"
                                v-model        = "current.projectnumber"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                            />
                        </v-col>

                        <v-col class="no-frame pl-2 col-6" v-if="!isModernization">
                            <f-date-picker
                                label   = "inc.edit.common.executionDate"
                                :time   = "false"
                                v-model = "current.executionDate"
                                class   = "w-100"
                                :rules  = "[ requiredOnExecution ]"
                            />
                        </v-col>
                    </v-row>

                    <!-- Incident-level field, shown in every bids step (not only index 0); dense to fit the fixed-height column -->
                    <v-row class="no-frame">
                        <v-col class="no-frame pr-2 col-6">
                            <f-date-picker
                                label             = "inc.edit.general.offerDate"
                                :time             = "false"
                                v-model           = "incident.offerDate"
                                :background-color = "fileEntryFieldBackground"
                                class             = "w-100 mb-2"
                                dense
                                hide-details
                            />
                        </v-col>
                    </v-row>

                    <v-row class="no-frame" v-if="isModernization">
                        <v-col class="no-frame pr-2" :class="isRebuild ? 'col-6  ' : 'col-12'">
                            <v-text-field
                                v-if           = "collective"
                                label          = "Auftragsnummer"
                                v-model        = "data.ordernumber"
                                :background-color = "fileEntryFieldBackground"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                @input         = "onOrdernumber"
                            />
                        </v-col>

                        <v-col class="no-frame pl-2" v-if="isRebuild">
                            <f-date-picker
                                label   = "repair.modernization.warranty"
                                :time   = "false"
                                v-model = "data.warranty"
                                class   = "w-100"
                                :background-color = "fileEntryFieldBackground"
                                :rules  = "[ requiredRule ]"
                            />
                        </v-col>
                    </v-row>

                    <inc-unit-down-interval
                        v-if      = "!previous && !isModernization"
                        :unitdata = "current"
                        :status   = "current.status"
                    />

                    <inc-processing-interval
                        v-if           = "!isModernization"
                        :data          = "data"
                        :status        = "current.status"
                        :background    = "fileEntryFieldBackground"
                        @start-changed = "validate"
                        @end-changed   = "validate"
                    />

                    <inc-processing-interval
                        v-if           = "isModernization"
                        :data          = "data"
                        :status        = "current.status"
                        :background    = "fileEntryFieldBackground"
                        label          = "repair.modernization.start"
                        label2         = "repair.modernization.end"
                        class="pr-2"
                        @start-changed = "validate"
                        @end-changed   = "validate"
                    />

                    <v-row class="no-frame" v-if="index !== 0">
                        <v-col class="no-frame pr-2 col-6">
                            <f-date-picker
                                label   = "inc.edit.common.executionDate"
                                :time   = "false"
                                v-model = "current.executionDate"
                                class   = "w-100"
                                :rules  = "[ requiredOnExecution ]"
                            />
                        </v-col>
                        <v-col class="no-frame pl-2 col-6">
                            <v-switch
                                v-if    = "isCollectivBidSelectable"
                                v-model = "data.collective"
                                label   = "Sammelangebot"
                                class   = "mt-0 mb-2 pt-5 mr-2"
                                :ripple = "false"
                                @change = "onBidTypeChanged"
                                hide-details
                            />
                        </v-col>
                    </v-row>

                    <v-row class="no-frame mt-1 pr-2" v-if="data.tags.includes('description')">
                        <v-textarea
                            v-if           = "!previousCurrent"
                            label          = "Beschreibung"
                            v-model        = "current.description"
                            :rows          = "isModernization ? 5: 4"
                            autocomplete   = "off"
                            autocorrect    = "off"
                            autocapitalize = "off"
                            spellcheck     = "false"

                            no-resize
                        />
                        <v-textarea
                            v-if           = "previousCurrent && previousCurrent.description"
                            label          = "Beschreibung"
                            v-model        = "previousCurrent.description"
                            rows           = "4"
                            autocomplete   = "off"
                            autocorrect    = "off"
                            autocapitalize = "off"
                            spellcheck     = "false"
                            no-resize
                        />
                    </v-row>
                    <v-row v-if="data.tags.includes('components')">
                        <inc-components
                            v-model       = "current.components"
                            :site         = "unit"
                            :warranties   = "warranties"
                            :incident     = "incident"
                            :status       = "status"
                            :height       = "isModernization ? 218 : 140"
                            :zoom-allowed = "true"
                            style         = "border-radius: 5px 0 5px 5px; margin-top: -1px"
                            @input        = "onComponents"
                            @zoom         = "onZoomComponents"
                            class         = "w-100 pr-2"
                        />
                    </v-row>
                    <v-row class="no-frame mt-5" v-if="!isModernization">
                        <v-col class="no-frame mr-2">
                            <v-text-field
                                v-if           = "collective"
                                label          = "Auftragsnummer"
                                v-model        = "data.ordernumber"
                                :background-color = "fileEntryFieldBackground"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                @input         = "onOrdernumber"
                            />
                            <v-text-field
                                v-if           = "!collective"
                                label          = "Auftragsnummer"
                                v-model        = "current.ordernumber"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                @input         = "onOrdernumber"
                            />
                        </v-col>
                        <v-col class="no-frame ml-2" >
                            <f-read-only-field
                                v-if  = "data.invoice && collective"
                                label = "Rechnungsnummer"
                                :value = "invoicenumber"
                                collective
                                dense
                            />
                            <f-read-only-field
                                v-if  = "data.invoice && !collective"
                                label = "Rechnungsnummer"
                                :value = "invoicenumber"
                                filled
                                dense
                            />
                        </v-col>
                    </v-row>
                </div>
            </drop>
        </v-col>

        <v-col class="step-middle-column">
            <div v-if="!isBidsNecessary">
                <v-row class="mt-11">
                    <inc-status
                        v-model = "current.status"
                        :items  = "fullMaintenanceStatus"
                        class   = "mt-0"
                        @change = "onStatusChanged"
                    />
                </v-row>

                <v-row class="mt-4">
                    <v-col class="no-frame ">
                        <c-contact-select
                            v-if        = "data.manufacturer"
                            v-model     = "data.contactIds"
                            label       = "Kontakte"
                            class       = "w-100"
                            :company-id = "data.manufacturer ? data.manufacturer.id : null"
                            :incident   = "incident"
                            :index      = "index"
                            :status     = "current.status"
                            @sendmail   = "onSendmail"
                        />
                    </v-col>
                </v-row>
                <v-row class="mt-5">
                    <v-col class="no-frame ">
                        <f-read-only-field
                            label  = "Email Ansprechpartner"
                            :value = "mntContact ? mntContact.name : null"
                        />
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-textarea
                        v-model = "current.measure"
                        :rules  = "[requiredOnTerminationRule]"
                        :rows   = "4"
                        label   = "Maßnahme"
                        no-resize
                    />
                </v-row>
                <c-v-spacer />
            </div>

            <v-row class="no-frame" v-if="isBidsNecessary">
                <inc-bid
                    :bid            = "bids[0]"
                    :incident       = "incident"
                    :data           = "data"
                    :status         = "step.status"
                    :sites          = "bidUnits"
                    :bus            = "bus"
                    :form           = "form"
                    :index          = "index"
                    :readonly       = "readonly"
                    :step           = "step"
                    @zoom           = "onZoom"
                    @status-changed = "onStatusChanged"
                    @refresh        = "onRefresh"
                    @sendmail       = "onBidMail"
                    @save           = "onSave"
                />
            </v-row>
        </v-col>
        <v-col class="step-middle-column">

            <v-row class="mt-14" v-if="!isBidsNecessary">
                <v-col class="no-frame ">
                    <f-title :title="$t('inc.edit.invoice.warranty')" class="mt-1"/>
                    <inc-warranty-edit
                        :site ="current"
                    />
                </v-col>
            </v-row>


            <v-row class="no-frame" v-if="isBidsNecessary">
                <inc-bid
                    :bid      = "bids[1]"
                    :incident = "incident"
                    :data     = "data"
                    :status   = "step.status"
                    :sites    = "bidUnits"
                    :bus      = "bus"
                    :form     = "form"
                    :index    = "index"
                    :readonly = "readonly"
                    :step     = "step"
                    @favorite = "onFavorite"
                    @refresh  = "onRefresh"
                    @zoom     = "onZoom"
                    @sendmail = "onBidMail"
                    @save     = "onSave"
                />
            </v-row>
        </v-col>
        <v-col class="step-last-column">
            <v-row class="no-frame mb-1" v-show="!notice"  v-if="isBidsNecessary">
                <v-carousel
                    v-model         ="currentBid"
                    :continuous     ="false"
                    :cycle          ="false"
                    :show-arrows    ="false"
                    :hide-delimiters="true"
                    height          ="100%"
                    class="pa-0 ma-0"
                    light
                >
                    <v-carousel-item v-for="(bid, i) in bids.slice (2)" :key="i">
                        <v-sheet height="100%" tile>
                            <inc-bid
                                :bid      = "bid"
                                :incident = "incident"
                                :data     = "data"
                                :status   = "step.status"
                                :sites    = "bidUnits"
                                :bus      = "bus"
                                :form     = "form"
                                :index    = "index"
                                :readonly = "readonly"
                                :step     = "step"
                                @favorite = "onFavorite"
                                @refresh  = "onRefresh"
                                @zoom     = "onZoom"
                                @sendmail = "onBidMail"
                                @status-changed = "onStatusChanged"
                                @save     = "onSave"
                            >
                            </inc-bid>
                        </v-sheet>
                    </v-carousel-item>
                </v-carousel>
            </v-row>

            <v-row
                class="no-frame mt-0 bid-navigation "
                v-show="!notice"
                v-if="isBidsNecessary"
            >
                <a v-for="(bid, i) in bids.slice (2)" :key="i"
                   class="delimiter primary"
                   :class="currentBid===i?'selected':''"
                   @click="currentBid=i">
                </a>
            </v-row>

            <v-row class="bid-notice-column" v-show="notice">
                <crm-journal
                    :incident="incident"
                    @front   ="onJournalFront"
                    @saved="success=true"
                />
            </v-row>
        </v-col>
    </v-row>
</v-container>
